<template>
  <v-dialog persistent :value="show" max-width="1000">
    <v-card>
      <button style="width: 1px; height: 1px; display: none"></button>
      <div class="text-xs-right">
        <v-btn name="close" small flat fab @click="onClose">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <div class="list-categories pb-3">
          <!-- <draggable :list="categorylist" class="dragArea" @change="checkMove">
            
          </draggable>-->
          <div>
            <div
              class="category"
              v-for="(category, index) in categorylist"
              :key="'category_' + index"
            >
              <ecommerce-category-edit
                :categorylist="categorylist"
                v-model="categorylist[index]"
                :prefix="prefix"
                @onDelete="onDeleteCategory(index, $event)"
              >
                <template slot="move">
                  <move-vertical
                    :index="index"
                    :max="categorylist.length"
                    @onMove="onMove(index, $event)"
                    style="width: 20px;min-width: 20px;display: inline-block;float: left;margin-right: 10px;"
                  >
                    <div></div>
                  </move-vertical>
                </template>
              </ecommerce-category-edit>
            </div>
            <div v-if="productBy !== 'zortOut'">
              <div
                class="btn-add text-xs-center"
                style="padding: 20px 0;"
                v-if="!isAdd"
                @click="onAddNew"
              >
                <i class="fa fa-plus"></i>
                {{ $t('Add new categories') }}
              </div>
              <div class="category" v-else>
                <div style="margin-bottom: 0;">
                  <div v-if="isLoading" class="spinner text-xs-center">
                    <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
                  </div>
                  <template v-else>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <div
                          class="category-name form-control"
                          :class="{ 'has-error': errors.has('categoryname') }"
                          style="width: 100%"
                        >
                          <input
                            v-validate="`excluded: ${categoryname}`"
                            ref="newCategory"
                            type="text"
                            name="categoryname"
                            :data-vv-as="$t('Category name')"
                            v-model="newCategory.name"
                            :placeholder="$t('Enter Category Name')"
                          />
                          <span class="text-error" v-if="errors.has('categoryname')">{{
                            errors.first('categoryname')
                          }}</span>
                        </div></v-flex
                      >
                    </v-layout>
                    <div class="text-xs-center">
                      <v-btn outline color="grey" @click="onCancelAddCategory">{{
                        $t('cancel')
                      }}</v-btn>
                      <v-btn depressed color="primary" @click="onAddCategory">{{
                        $t('Save')
                      }}</v-btn>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import MoveVertical from '@/components/elements/MoveVertical'
import ecommerceCategoryEdit from './ecommerce-category-edit'
import api from '@/api'

export default {
  props: ['value', 'show', 'prefix', 'productBy'],
  computed: {
    categoryname() {
      return this.categorylist.map(v => v.name)
    },
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    }
  },
  data: function() {
    return {
      categorylist: this.value,
      currentCategory: null,
      currentSubCategory: null,
      newCategory: {
        name: null
      },
      isLoading: false,
      newSubCategory: {
        name: null
      },
      showEdit: false,
      isAdd: false
    }
  },
  mounted: function() {
    let vm = this
    // document.addEventListener('keydown', e => {
    //   if (e.keyCode == 27) {
    //     vm.$emit('close')
    //   }
    // })
  },
  components: {
    'ecommerce-category-edit': ecommerceCategoryEdit,
    MoveVertical
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onMove(index, direction) {
      var vm = this
      if (direction == 'up') {
        vm.categorylist.splice(index, 0, vm.categorylist.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        vm.categorylist.splice(index, 0, vm.categorylist.splice(index + 1, 1)[0])
      }
      this.checkMove()
    },
    onAddNew: function() {
      var vm = this
      vm.isAdd = true
      vm.$nextTick(function() {
        vm.$refs.newCategory.focus()
      })
    },
    close: function() {
      let vm = this
      vm.showEdit = false
      vm.nextTick(function() {
        // vm.$emit('input',vm.product)
      })
    },
    checkMove: function(e) {
      // e.newIndex
      // e.oldIndex
      let vm = this
      let input = []
      input = vm.categorylist.map((el, index) => {
        return { id: el.id, priority: index }
      })

      api.putprioritycategories({ input, pageid: this.pageid }, function(error, response) {
        if (error) {
          console.error(error)
          vm.isLoading = false
          return
        }
      })

      vm.$emit('input', vm.categorylist)
    },
    onEditCategory: function(index) {
      this.currentCategory = this.categorylist[index]
      this.showEdit = true
    },
    onSelectCategory: function(index) {
      this.currentCategory = this.categorylist[index]
    },
    // pressAddEnter: function(e) {
    //   if (e.keyCode === 13) {
    //     this.onAddCategory()
    //   }
    // },
    onCancelAddCategory: function() {
      var vm = this
      vm.newCategory.name = ''
      vm.newCategory.display_name = ''
      vm.isAdd = false
    },
    onAddCategory: function() {
      let vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.newCategory.name == null || vm.newCategory.name.trim() == '') {
          vm.newCategory.name = ''
          vm.newCategory.display_name = ''
          vm.isAdd = false
          return false
        }
        vm.newCategory.name = (vm.prefix ? vm.prefix + '/' : '') + vm.newCategory.name
        let data = {
          pageid: vm.pageid,
          name: vm.newCategory.name,
          display_name: vm.newCategory.display_name
        }
        vm.isLoading = true
        api.saveCategory(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.isLoading = false
            return
          }

          vm.newCategory.id = response.categoryid
          vm.newCategory.subcategories = []

          vm.categorylist.push(vm.newCategory)
          vm.newCategory = { name: null }
          vm.isAdd = false
          vm.isLoading = false
          vm.$emit('input', vm.categorylist)
          vm.$emit('onCategoryChange')
        })
      })
    },
    onDeleteCategory: function(index, payload) {
      let vm = this
      vm.$swal
        .fire({
          title: `${vm.$t('Do you want to delete {name}?', {
            name: vm.categorylist[index].name.replace(/\<|\>/g, '')
          })} 
          ${vm.$t('If deleted, the products in this category will also be deleted.')}`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          focusConfirm: true
        })
        .then(result => {
          if (result.value) {
            api.deleteCategory(payload, function(error, response) {
              if (error) {
                console.error(error)
                return
              }

              vm.categorylist.splice(index, 1)
              vm.$emit('input', vm.categorylist)
              vm.$emit('onCategoryChange')
              vm.$emit('deleteCategory', payload)
            })
          }
        })
    },
    onAddSubCategory: function() {
      let vm = this
      let data = {
        pageid: vm.pageid,
        name: vm.newSubCategory.name,
        categoryid: vm.currentCategory.id
      }
      api.saveSubCategory(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        vm.newSubCategory.id = response.subcategoryid

        let categoryIndex = vm.categorylist.findIndex(category => {
          return category.id == vm.currentCategory.id
        })
        vm.categorylist[categoryIndex].subcategories.push(vm.newSubCategory)
        vm.newSubCategory = { name: null }
      })
    },
    onEditSubCategory: function(index) {
      this.currentSubCategory = this.currentCategory.subcategories[index]
    },
    onDeleteSubCategory: function(index, id) {
      if (confirm('Do you want to delete this?')) {
        let vm = this
        api.deleteSubCategory(id, function(error, response) {
          if (error) {
            console.error(error)
            return
          }

          vm.currentCategory.subcategories.splice(index, 1)
        })
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.categorylist = newVal
    }
  }
}
</script>

<style>
.list-category-group {
  text-decoration: none;
  list-style-type: none;
  padding-left: 0px;
}

.list-category:first-child {
  border-top: 1px solid #eee;
}

.list-category {
  padding: 10px;

  border-bottom: 1px solid #eee;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}

.list-category.active {
  background-color: #007bff;
  color: white;
}

.grab {
  cursor: -webkit-grab;
  cursor: grab;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Categories.vue